import React from 'react';
import {Column} from 'primereact/column';
import BaseTable from 'components/tables/BaseTable';
import {useListKpiTargetsQuery} from "../../apis/kpiApi";
import {useListCompanyAccountsQuery} from "../../apis/companiesApi";
import SAMScoreboardYTDActual from "./SAMScoreboardYTDActual";
import SAMScoreboardYTDGoal from "./SAMScoreboardYTDGoal";

const SAMScoreboardTable = ({year}) => {
    const {data: kpiTargets, isFetching: isFetchingKpiTargets} = useListKpiTargetsQuery();
    const {data: companyUsers} = useListCompanyAccountsQuery();

    if(isFetchingKpiTargets) {
        return (<></>);
    }

    const sortedArray = [...(kpiTargets || [])].filter(kpi => kpi.scorecard && kpi.year === year && (kpi.timeFrame === 'Annual') && (kpi.type === 'Benchmark' || kpi.type === 'Target'));
    sortedArray.sort((targetA, targetB) => targetB.weight - targetA.weight);

    const responsibleBodyTemplate = (rowData) => {
        if(!companyUsers) return "-";
        const user = companyUsers.find(user => user.id === rowData?.responsible);

        return user ? (user?.registered ? `${user?.firstName} ${user?.lastName}` : user?.email) :
            "-";
    }

    const ytdTemplate = (rowData) => {
        return (<SAMScoreboardYTDActual target={rowData} />);
    }

    const ytdGoalTemplate = (rowData) => {
        return (<SAMScoreboardYTDGoal target={rowData} />);
    }

    return (
        <BaseTable
            title="Scoreboard"
            isLoading={isFetchingKpiTargets}
            emptyMessage="No Scoreboards found."
            dataList={sortedArray}>
            <Column field="name" header="Name" />
            <Column field="responsible" header="Responsible" body={responsibleBodyTemplate} />
            <Column field="ytd" header="YTD Actual" body={ytdTemplate} />
            <Column field="ytdGoal" header="YTD Goal" body={ytdGoalTemplate} />
        </BaseTable>
    )
}

export default SAMScoreboardTable;
